import { useCallback, useEffect, useMemo, useState } from 'react';
import { useChat } from '../context/ChatContext';
import ChatTasksPanel from '../components/ChatTasksPanel';
import { getMyChatTasks, acceptChatTask, completeChatTask, deleteChatTask, createTaskChat, cancelTaskChat } from '../api/chat';
import { acceptCustTask, completeCustTask, deleteCustTask } from '../api/customerChat';
import TaskChatArchiveModal from '../components/TaskChatArchiveModal';

// Trang "Công việc chat" (dưới menu Tin nhắn): TỔNG HỢP mọi công việc của tôi từ MỌI nhóm chat +
// chat KH — việc được giao cho tôi và việc tôi giao cho người khác. Bấm tên nhóm để mở thẳng đoạn chat.
export default function ChatTasksHubPage() {
  const { me, deepOpenConv } = useChat();
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('all'); // all | assigned (được giao cho tôi) | created (tôi giao)

  const load = useCallback(() => {
    setLoading(true);
    getMyChatTasks().then((d) => setTasks(Array.isArray(d) ? d : [])).catch(() => setTasks([])).finally(() => setLoading(false));
  }, []);
  useEffect(() => { load(); }, [load]);

  const byId = useMemo(() => new Map(tasks.map((t) => [t.id, t])), [tasks]);
  const call = useCallback(async (id, fnInternal, fnCustomer, ...args) => {
    const t = byId.get(id);
    if (!t) return;
    if (t.source === 'customer') await fnCustomer(t.conv.id, id, ...args);
    else await fnInternal(t.conv.id, id, ...args);
    load(); // đồng bộ lại toàn bộ
  }, [byId, load]);

  const onAccept = useCallback((id) => call(id, acceptChatTask, acceptCustTask), [call]);
  const onComplete = useCallback((id, done) => call(id, completeChatTask, completeCustTask, done), [call]);
  const onDelete = useCallback(async (id) => { if (window.confirm('Xoá công việc này?')) await call(id, deleteChatTask, deleteCustTask); }, [call]);
  const onOpenConv = useCallback((t) => deepOpenConv && deepOpenConv(t.conv.id, t.source === 'customer' ? 'customer' : undefined), [deepOpenConv]);

  // NHÓM CHAT RIÊNG cho công việc (chỉ việc nội bộ).
  const [archiveConvId, setArchiveConvId] = useState(null); // đang xem lại đoạn chat đã lưu trữ
  const onCreateChat = useCallback(async (t) => {
    try {
      const d = await createTaskChat(t.conv.id, t.id);
      load();
      if (d?.convId && deepOpenConv) deepOpenConv(d.convId); // mở thẳng nhóm vừa tạo
    } catch (e) { window.alert(e?.response?.data?.message || 'Không tạo được nhóm chat'); }
  }, [load, deepOpenConv]);
  const onCancelChat = useCallback(async (t) => {
    if (!window.confirm('Huỷ nhóm chat của công việc này? Nội dung vẫn được lưu để xem lại.')) return;
    try { await cancelTaskChat(t.conv.id, t.id); load(); }
    catch (e) { window.alert(e?.response?.data?.message || 'Không huỷ được nhóm chat'); }
  }, [load]);
  const onOpenChatGroup = useCallback((t) => { if (t.chatConv && deepOpenConv) deepOpenConv(t.chatConv); }, [deepOpenConv]);
  const onViewArchived = useCallback((t) => { if (t.chatConv) setArchiveConvId(t.chatConv); }, []);

  const shown = useMemo(() => {
    if (tab === 'assigned') return tasks.filter((t) => t.iAmAssignee);
    if (tab === 'created') return tasks.filter((t) => t.iAmCreator && !t.iAmAssignee);
    return tasks;
  }, [tasks, tab]);

  const cAssigned = tasks.filter((t) => t.iAmAssignee).length;
  const cCreated = tasks.filter((t) => t.iAmCreator && !t.iAmAssignee).length;
  const openMine = tasks.filter((t) => t.iAmAssignee && !t.done).length;

  return (
    <div className="page">
      <div className="page-head">
        <div>
          <h2>Công việc chat</h2>
          <div className="sub">Tổng hợp mọi công việc từ các nhóm chat & chat khách hàng · {openMine} việc của bạn chưa xong</div>
        </div>
        <button className="btn sm ghost" onClick={load}>⟳ Làm mới</button>
      </div>

      <div style={{ display: 'flex', gap: 8, margin: '0 0 14px', flexWrap: 'wrap' }}>
        <button className={'btn sm' + (tab === 'all' ? '' : ' ghost')} onClick={() => setTab('all')}>Tất cả ({tasks.length})</button>
        <button className={'btn sm' + (tab === 'assigned' ? '' : ' ghost')} onClick={() => setTab('assigned')}>Được giao cho tôi ({cAssigned})</button>
        <button className={'btn sm' + (tab === 'created' ? '' : ' ghost')} onClick={() => setTab('created')}>Tôi giao ({cCreated})</button>
      </div>

      <div className="card" style={{ maxWidth: 760 }}>
        {loading ? (
          <div className="small muted" style={{ padding: 8 }}>Đang tải…</div>
        ) : (
          <ChatTasksPanel
            tasks={shown}
            me={me}
            hideCreate
            onAccept={onAccept}
            onComplete={onComplete}
            onDelete={onDelete}
            onOpenConv={onOpenConv}
            onCreateChat={onCreateChat}
            onCancelChat={onCancelChat}
            onOpenChatGroup={onOpenChatGroup}
            onViewArchived={onViewArchived}
          />
        )}
      </div>
      {archiveConvId && (
        <TaskChatArchiveModal chatConvId={archiveConvId} meId={me?.id || me?._id} onClose={() => setArchiveConvId(null)} />
      )}
    </div>
  );
}
